import { __read, __spread } from "tslib";
import { convertDate } from '@keen.io/time-utils';
import { KEEN_KEY, KEEN_VALUE } from '../../constants';
export var defaultTransformation = function (result, dateModifier) {
    var data = [];
    var keys = new Set();
    result.forEach(function (interval) {
        var _a;
        var _b = interval, value = _b.value, startDate = _b.timeframe.start;
        keys.add(KEEN_VALUE);
        data.push((_a = {},
            _a[KEEN_KEY] = convertDate(startDate, dateModifier),
            _a[KEEN_VALUE] = value,
            _a));
    });
    return {
        data: data,
        keys: __spread(keys),
    };
};
